<template>
  <div>
    <el-container style="height: 100%">
      <el-aside style="width: 230px; height: 100%; background: #485b7f">
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          @select="handleSelect"
          :router="true"
          active-text-color="rgba(126, 170, 255, 1)"
          background-color="#485b7f"
          text-color="#fff"
        >
          <el-menu-item index="/">
            <template slot="title">
              <i class="el-icon-help"></i>
              <span>数据统计</span>
            </template>
            <!-- <el-menu-item-group>
              <el-menu-item
                index="/carDCDList">
                <span slot="title">线索列表</span>
              </el-menu-item>
              <el-menu-item
                index="/carDCD">
                <span slot="title">关联列表</span>
              </el-menu-item>
              <el-menu-item
                index="/carDCDmodel">
                <span slot="title">DCD车型</span>
              </el-menu-item>
              <el-menu-item
                index="/carDCDStores">
                <span slot="title">DCD经销商</span>
              </el-menu-item>
            </el-menu-item-group> -->
          </el-menu-item>

          <el-submenu
            index="1"
            v-if="
              $utils.checkPer('user.index') ||
              $utils.checkPer('permission.index') ||
              $utils.checkPer('role.index') ||
              $utils.checkPer('car-special-offer.index') ||
              $utils.checkPer('car-brand.index') ||
              $utils.checkPer('car-series.index')
            "
          >
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>品牌管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/car-brand"
                v-if="$utils.checkPer('car-brand.index')"
              >
                <span slot="title">品牌管理</span>
              </el-menu-item>
              <el-menu-item
                index="/car-series"
                v-if="$utils.checkPer('car-series.index')"
              >
                <span slot="title">车系管理</span>
              </el-menu-item>
              <el-menu-item
                index="/car-special-offer"
                v-if="$utils.checkPer('car-special-offer.index')"
              >
                <span slot="title">出口车型</span>
              </el-menu-item>
              <el-menu-item
                index="/car-special-admin"
                v-if="$utils.checkPer('user.index')">
                <span slot="title">车型审核</span>
              </el-menu-item>
              <!-- <el-menu-item
                index="/car-rabking"
                v-if="
                  $utils.checkPer('car-rabking') ||
                  $utils.checkPer('car-rabking')
                "
              >
                <span slot="title">车系排行</span>
              </el-menu-item> -->
            </el-menu-item-group>
          </el-submenu>
          <el-submenu
            index="2"
            v-if="
              $utils.checkPer('user.index') ||
              $utils.checkPer('permission.index') ||
              $utils.checkPer('role.index') ||
              $utils.checkPer('car-advertising.index')
            ">
            <template slot="title">
              <i class="el-icon-s-data"></i>
              <span>活动管理</span>
            </template>
            <!-- <el-menu-item
              index="/car-group"
              v-if="$utils.checkPer('car-group.index')"
            >
              <span slot="title">团购管理</span>
            </el-menu-item> -->
            <!-- <el-menu-item
              index="/car-activities"
              v-if="$utils.checkPer('car-activities.index')"
            >
              <span slot="title">资讯管理</span>
            </el-menu-item> -->
            <el-menu-item
              index="/car-advertising"
              v-if="$utils.checkPer('car-advertising.index')"
            >
              <span slot="title">广告管理</span>
            </el-menu-item>
          </el-submenu>
          <el-submenu
            index="3"
            v-if="
              $utils.checkPer('user.index') ||
              $utils.checkPer('permission.index') ||
              $utils.checkPer('role.index') ||
              $utils.checkPer('car-advertising.index')
            ">
            <template slot="title">
              <i class="el-icon-s-data"></i>
              <span>车友报名</span>
            </template>
            <el-menu-item
              index="/car-user-sign"
              v-if="$utils.checkPer('car-user-sign.index')"
            >
              <span slot="title">抽奖报名</span>
            </el-menu-item>
            
            <el-menu-item
              index="/car-user-signOne"
              v-if="$utils.checkPer('car-user-sign.index')"
            >
              <span slot="title">星途惠济万达</span>
            </el-menu-item>
            <el-menu-item
              index="/car-user-signTwo"
              v-if="$utils.checkPer('car-user-sign.index')"
            >
              <span slot="title">星途探十里</span>
            </el-menu-item>
          </el-submenu>

          <!-- <el-submenu
            index="3"
            v-if="
              $utils.checkPer('user.index') ||
              $utils.checkPer('permission.index') ||
              $utils.checkPer('role.index')
            "
          >
            <template slot="title">
              <i class="el-icon-price-tag"></i>
              <span>日志管理</span>
            </template>
            <el-menu-item
              index="/car-price-log"
              v-if="$utils.checkPer('car-price-log.index')"
            >
              <span slot="title">价格日志</span>
            </el-menu-item>
          </el-submenu> -->

          <!-- <el-submenu
            index="4"
            v-if="
              $utils.checkPer('user.index') ||
              $utils.checkPer('permission.index') ||
              $utils.checkPer('role.index')
            "
          >
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span>车友管理</span>
            </template>
            <el-menu-item
              index="/car-user"
              v-if="$utils.checkPer('car-user.index')"
            >
              <span slot="title">车友管理</span>
            </el-menu-item>
            <el-menu-item
              index="/car-user-sign"
              v-if="$utils.checkPer('car-user-sign.index')"
            >
              <span slot="title">车友报名</span>
            </el-menu-item>
            <el-menu-item
              index="/car-score"
              v-if="$utils.checkPer('car-score.index')"
            >
              <span slot="title">车友口碑</span>
            </el-menu-item>
            <el-menu-item
              index="/car-user-price"
              v-if="$utils.checkPer('car-user-price.index')"
            >
              <span slot="title">车友价格</span>
            </el-menu-item>
            <el-menu-item
              index="/car-history"
              v-if="
                $utils.checkPer('history') || $utils.checkPer('history-select')
              "
            >
              <span slot="title">浏览记录</span>
            </el-menu-item>
          </el-submenu> -->

          <!-- <el-submenu index="5">
            <template slot="title">
              <i class="el-icon-help"></i>
              <span>微信抽奖</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/shoppingList">
                <span slot="title">商品列表</span>
              </el-menu-item>
              <el-menu-item
                index="/cargoodsList">
                <span slot="title">订单列表</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu> -->

          

          
          <el-menu-item
            index="/account-management"
            v-if="
              $utils.checkPer('user.index') ||
              $utils.checkPer('permission.index') ||
              $utils.checkPer('role.index')
            "
          >
            <i class="el-icon-user"></i>
            <span slot="title">账号管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>


      <el-main>
        <transition :name="type">
          <router-view v-show="show"></router-view>
        </transition>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "my-main",
  //type 随机动画
  props: ["type"],
  data() {
    return {
      show: true,
    };
  },
  created() {
    // fullPath 完整路径
    console.log(this.$route.path);
    if (
      this.$route.fullPath == "/car-brand" &&
      this.$utils.checkPer("car-tiktok-game.index") &&
      this.$utils.checkPer("car-brand.index") &&
      !this.$utils.checkPer("car-brand.store")
    ) {
      //抖音挑战赛
      this.$router.push({ path: "/car-tiktok-game" });
      return;
    }
    //if(this.$route.fullPath !== '/') return;
    // if (this.$utils.checkPer("car-brand.index") && this.$utils.checkPer("car-brand.store")) {
    //   //首页
    //   this.$router.push({ path: "/car-brand" });
    // } else if (this.$utils.checkPer("car-series.index")) {
    //   //车系管理
    //   this.$router.push({ path: "/car-series" });
    // } else if (this.$utils.checkPer("car-model.index")) {
    //   //车型管理
    //   this.$router.push({ path: "/car-model" });
    // } else if (this.$utils.checkPer("car-score.index")) {
    //   //积分管理
    //   this.$router.push({ path: "/car-score" });
    // } else if (this.$utils.checkPer("car-group.index")) {
    //   //团购管理
    //   this.$router.push({ path: "/car-group" });
    // } else if (this.$utils.checkPer("car-user-price.index")) {
    //   //车友价格
    //   this.$router.push({ path: "/car-user-price" });
    // } else if (this.$utils.checkPer("car-user-sign.index")) {
    //   //车友报名管理
    //   this.$router.push({ path: "/car-user-sign" });
    // }
  },
  methods: {
    handleSelect(key, keyPath) {
      let arr = [
        "el-zoom-in-center",
        "el-fade-in-linear",
        "el-fade-in",
        "el-zoom-in-top",
        "el-zoom-in-bottom",
      ];
      let type = arr[Math.floor(Math.random() * 5)];
      this.$emit("selected", { type: type });
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style scoped>
/* .el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  color: #333;
  text-align: center;
  line-height: 200px;
  height: calc(100vh - 96px);
  background-color: #485b7f;
}

.el-submenu__title {
  padding-left: 0 !important;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  line-height: 160px;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
} */
</style>
